

import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicModel } from "../../model/BasicModel";
import { SimpleCommand } from './../../../commanding/SimpleCommand';

export class BasicInviteFriendCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        let params: any[] = (<any[]>commandVars);

        if (!params || params.length != 3) {
            return;
        }
        let myname: string = String(params.shift());
        let name: string = String(params.shift());
        let mail: string = String(params.shift());
        BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_INVITE_FRIEND, [myname, name, mail]);
    }
}

